<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator';
const STORE_MODULE_NAME = 'AttendanceModule';

export default {
  name: 'WrapperAttendance',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
